import "./styles/App.css";
import { Routes, Route } from "react-router-dom";
import SignIn from "./modules/auth/SignIn";
import ProtectedRoute from "./modules/auth/ProtectedRoute";
import PublicRoute from "./modules/auth/PublicRoute";
import ForgotPassword from "./modules/auth/ForgotPassword";
import ResetPassword from "./modules/auth/ResetPassword";
import SubscriptionBlocked from "./modules/auth/SubscriptionBlocked";
import LayoutWrapper from "./layouts/LayoutWrapper";
import GrowthAnalytics from "./modules/dashboards/GrowthAnalyticsPage";
import AdminDashboard from "./modules/dashboards/AdminDashboard";
import SuperAdminDashboard from "./modules/dashboards/SuperAdminDashboard";
import TeacherDashboard from "./modules/dashboards/TeacherDashboard";
import StudentDashboard from "./modules/dashboards/StudentDashboard";
import Teachers from "./modules/users/Teachers";
import Headteachers from "./modules/users/Headteachers";
import AddUser from "./modules/users/AddUser";
import UsersPage from "./modules/users/UsersPage";
import AllClasses from "./modules/academics/AllClasses";
import ClassDetails from "./modules/academics/ClassDetails";
import StudentsPerformance from "./modules/academics/StudentsPerformance";
import MyAttendance from "./modules/academics/MyAttendance";
import MyGrades from "./modules/academics/MyGrades";
import MySubjects from "./modules/academics/MySubjects";
import MyTimetable from "./modules/academics/MyTimetable";
import UniformsManagement from "./modules/admin/UniformsManagement";
import FeesManagementSimple from "./modules/finance/FeesManagementSimple";
import LibraryManagement from "./modules/library/LibraryManagement";
import FinancialReports from "./modules/finance/FinancialReports";
import UniformShop from "./modules/student/UniformShop";
import StudentFees from "./modules/student/StudentFeesPage";
import Students from "./modules/users/Students";
import Subjects from "./modules/academics/Subjects";
import ClassSubjects from "./modules/academics/ClassSubject";
import ClassTeacher from "./modules/academics/ClassTeacher";
import StudentsInClass from "./modules/academics/StudentsInClass";
import LearnerPromotion from "./modules/academics/LearnerPromotion";
import ClassesPage from "./modules/academics/ClassesPage";
import AttendanceRegister from "./modules/academics/AttendanceRegister";
import SchoolSettings from "./modules/admin/SchoolSettings";
import SchoolsManagement from "./modules/admin/SchoolsManagement";
import SchoolForm from "./modules/admin/SchoolFormPage";
import SchoolDetails from "./modules/admin/SchoolDetails";
import AdminForm from "./modules/admin/AdminForm";
import SubscriptionsManagement from "./modules/finance/SubscriptionsManagement";
import SubscriptionForm from "./modules/finance/SubscriptionForm";
import AuditTrail from "./modules/admin/AuditTrailPage";
import PayrollManagement from "./modules/finance/PayrollManagement";
import PayrollPeriods from "./modules/finance/PayrollPeriods";
import PayrollComponents from "./modules/finance/PayrollComponents";
import SchoolExpenses from "./modules/finance/SchoolExpenses";
import MyPayroll from "./modules/finance/MyPayrollPage";
import MyPayslipDetail from "./modules/finance/MyPayslipDetail";
import ProfileSettings from "./modules/admin/ProfileSettingsPage";
import HeadteacherDashboard from "./modules/dashboards/HeadteacherDashboard";
import HeadteacherResults from "./modules/academics/HeadteacherResults";
import HeadteacherNotices from "./modules/admin/HeadteacherNotices";
import TransportRoutes from "./modules/admin/TransportRoutes";
import HeadteacherAttendance from "./modules/academics/HeadteacherAttendance";
import HeadteacherReportCards from "./modules/academics/HeadteacherReportCards";
import ReportCardsViewer from "./modules/academics/ReportCardsViewer";
import HeadteacherTeachers from "./modules/users/HeadteacherTeachers";
import HeadteacherLearners from "./modules/users/HeadteacherLearners";
import AssessmentsPage from "./modules/academics/AssessmentsPage";
import ViewTestResults from "./modules/academics/ViewAssessments";
import RecordTestResults from "./modules/academics/RecordAssessments";
import MessagesPage, { MessageHome } from "./modules/messaging/MessagesPage";
import MessageThreadPage from "./modules/messaging/MessageThread";
import Timetable from "./modules/academics/Timetable";
import GlobalUsersManagement from "./modules/admin/GlobalUsersManagement";
import GlobalSubjects from "./modules/academics/GlobalSubjects";
import GlobalClasses from "./modules/academics/GlobalClasses";
import RolesPermissions from "./modules/superadmin/RolesPermissions";
import FinancialOverview from "./modules/superadmin/FinancialOverviewPage";
import SystemSettings from "./modules/superadmin/SystemSettingsPage";
import SupportTickets from "./modules/superadmin/SupportTicketsPage";
import MaintenanceControls from "./modules/superadmin/MaintenanceControlsPage";
import BackupRestore from "./modules/superadmin/BackupRestore";
import BroadcastNotifications from "./modules/superadmin/BroadcastNotificationsPage";
import Integrations from "./modules/superadmin/IntegrationsPage";
import SubscriptionEnforcement from "./modules/superadmin/SubscriptionEnforcement";
import MaintenancePage from "./modules/shared/Maintenance";
import SchoolCalendar from "./modules/shared/SchoolCalendar";
import CalendarPage from "./modules/shared/CalendarPage";
import SupportDesk from "./modules/shared/SupportDeskPage";
import SchoolSubscription from "./modules/admin/SchoolSubscriptionPage";
import SettingsInsights from "./modules/admin/SettingsInsights";
import SettingsExport from "./modules/admin/SettingsExportPage";
function App() {
  return (
    <Routes>
      <Route element={<PublicRoute />}>
        <Route path="/" element={<SignIn />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
      </Route>
      <Route path="/maintenance" element={<MaintenancePage />} />
      <Route path="/subscription-blocked" element={<SubscriptionBlocked />} />
      <Route path="/analytics" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="dashboard" />}>
          <Route index element={<GrowthAnalytics />} />
        </Route>
      </Route>
      <Route path="/admindashboard" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="dashboard" />}>
          <Route index element={<AdminDashboard />} />
        </Route>
      </Route>
      <Route path="/add-user" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
          <Route index element={<AddUser />} />
        </Route>
      </Route>
      <Route path="/transport" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="transport" />}>
          <Route index element={<TransportRoutes />} />
        </Route>
      </Route>
      <Route path="/users" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="teachers" />}>
          <Route index element={<UsersPage />} />
        </Route>
      </Route>
      <Route path="/MySubjects" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['student']} requiredModule="classes" />}>
          <Route index element={<MySubjects />} />
        </Route>
      </Route>
      <Route path="/superadmin" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<SuperAdminDashboard />} />
        </Route>
      </Route>
      <Route path="/teacherdashboard" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['teacher']} requiredModule="dashboard" />}>
          <Route index element={<TeacherDashboard />} />
        </Route>
      </Route>

      {/* Teacher Assessment Routes */}
      <Route path="/assessments" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['teacher', 'admin']} requiredModule="results" />}>
          <Route index element={<AssessmentsPage />} />
        </Route>
      </Route>
      <Route path="/view-results" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['teacher', 'admin']} requiredModule="results" />}>
          <Route index element={<ViewTestResults />} />
        </Route>
      </Route>
      <Route path="/record-assessments" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['teacher', 'admin']} requiredModule="results" />}>
          <Route index element={<RecordTestResults />} />
        </Route>
      </Route>

      {/* Profile Settings Route */}
      <Route path="/settings/profile" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute />}>
          <Route index element={<ProfileSettings />} />
        </Route>
      </Route>
      <Route path="/dashboard" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['student']} requiredModule="dashboard" />}>
          <Route index element={<StudentDashboard />} />
        </Route>
      </Route>
      <Route path="/teachers" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="teachers" />}>
          <Route index element={<Teachers />} />
        </Route>
      </Route>
      <Route path="/headteachers" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="teachers" />}>
          <Route index element={<Headteachers />} />
        </Route>
      </Route>
      <Route path="/allclasses" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="classes" />}>
          <Route index element={<AllClasses />} />
        </Route>
      </Route>
      <Route path="/finance/feessummary" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin', 'headteacher']} requiredModule="fees" />}>
          <Route index element={<FeesManagementSimple />} />
        </Route>
      </Route>
      <Route path="/finance/fees" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin', 'headteacher']} requiredModule="fees" />}>
          <Route index element={<FeesManagementSimple />} />
        </Route>
      </Route>
      <Route path="/finance/payments" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin', 'headteacher']} requiredModule="fees" />}>
          <Route index element={<FeesManagementSimple />} />
        </Route>
      </Route>
      <Route path="/library" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin', 'headteacher', 'teacher']} requiredModule="library" />}>
          <Route index element={<LibraryManagement />} />
        </Route>
      </Route>
      <Route path="/events" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute />}>
          <Route index element={<CalendarPage />} />
        </Route>
      </Route>
      <Route path="/classdetails/:id" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin', 'headteacher', 'teacher']} requiredModule="classes" />}>
          <Route index element={<ClassDetails />} />
        </Route>
      </Route>
      <Route path="/studentperformance/:id" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin', 'headteacher', 'teacher']} requiredModule="results" />}>
          <Route index element={<StudentsPerformance />} />
        </Route>
      </Route>
      <Route path="/students" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="classes" />}>
          <Route index element={<Students />} />
        </Route>
      </Route>
      <Route path="/subjects" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="classes" />}>
          <Route index element={<Subjects />} />
        </Route>
      </Route>
      <Route path="/classsubjects" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="classes" />}>
          <Route index element={<ClassSubjects />} />
        </Route>
      </Route>
      <Route path="/classteacher" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="classes" />}>
          <Route index element={<ClassTeacher />} />
        </Route>
      </Route>
      <Route path="/studentsinclass" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="classes" />}>
          <Route index element={<StudentsInClass />} />
        </Route>
      </Route>
      <Route path="/academics/promotion" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin', 'headteacher']} requiredModule="classes" />}>
          <Route index element={<LearnerPromotion />} />
        </Route>
      </Route>
      <Route path="/shop/uniform-orders" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin', 'headteacher']} requiredModule="uniform_orders" />}>
          <Route index element={<UniformsManagement />} />
        </Route>
      </Route>
      <Route path="/my-grades" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['student']} requiredModule="results" />}>
          <Route index element={<MyGrades />} />
        </Route>
      </Route>
      <Route path="/student/subjects" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['student']} requiredModule="classes" />}>
          <Route index element={<MySubjects />} />
        </Route>
      </Route>
      <Route path="/student/timetable" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['student']} requiredModule="timetable" />}>
          <Route index element={<MyTimetable />} />
        </Route>
      </Route>
      <Route path="/student/attendance" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['student']} requiredModule="attendance" />}>
          <Route index element={<MyAttendance />} />
        </Route>
      </Route>
      <Route path="/student/reports" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['student']} requiredModule="report_cards" />}>
          <Route index element={<MyGrades />} />
        </Route>
      </Route>
      <Route path="/student/calendar" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['student']} requiredModule="dashboard" />}>
          <Route index element={<SchoolCalendar />} />
        </Route>
      </Route>
      <Route path="/student/fees" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['student']} requiredModule="fees" />}>
          <Route index element={<StudentFees />} />
        </Route>
      </Route>
      <Route path="/student/uniform" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['student']} requiredModule="uniform_orders" />}>
          <Route index element={<UniformShop />} />
        </Route>
      </Route>
      <Route path="/classes" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['teacher']} requiredModule="classes" />}>
          <Route index element={<ClassesPage />} />
        </Route>
      </Route>
      <Route path="/timetable" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['teacher', 'admin', 'headteacher']} requiredModule="timetable" />}>
          <Route index element={<Timetable />} />
        </Route>
      </Route>
      <Route path="/studentsperformance" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['teacher', 'admin']} requiredModule="results" />}>
          <Route index element={<ViewTestResults />} />
        </Route>
      </Route>
      <Route path="/attendance" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin', 'teacher']} requiredModule="attendance" />}>
          <Route index element={<AttendanceRegister />} />
        </Route>
      </Route>
      <Route path="/reports/finance" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="financial_reports" />}>
          <Route index element={<FinancialReports />} />
        </Route>
      </Route>
      <Route path="/finance/expenses" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin', 'superadmin']} requiredModule="expenses" />}>
          <Route index element={<SchoolExpenses />} />
        </Route>
      </Route>
      <Route path="/settings" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
          <Route index element={<SchoolSettings />} />
        </Route>
      </Route>
      <Route path="/settings/subscription" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
          <Route index element={<SchoolSubscription />} />
        </Route>
      </Route>
      <Route path="/settings/insights" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="dashboard" />}>
          <Route index element={<SettingsInsights />} />
        </Route>
      </Route>
      <Route path="/settings/export" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
          <Route index element={<SettingsExport />} />
        </Route>
      </Route>
      <Route path="/superadmin/schools" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<SchoolsManagement />} />
        </Route>
      </Route>
      <Route path="/superadmin/users" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<GlobalUsersManagement />} />
        </Route>
      </Route>
      <Route path="/superadmin/schools/new" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<SchoolForm />} />
        </Route>
      </Route>
      <Route path="/superadmin/schools/:id" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<SchoolDetails />} />
        </Route>
      </Route>
      <Route path="/superadmin/schools/:id/edit" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<SchoolForm />} />
        </Route>
      </Route>
      <Route path="/superadmin/schools/:schoolId/admins/new" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<AdminForm />} />
        </Route>
      </Route>
      <Route path="/superadmin/schools/:schoolId/admins/:adminId/edit" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<AdminForm />} />
        </Route>
      </Route>
      <Route path="/superadmin/subscriptions" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<SubscriptionsManagement />} />
        </Route>
      </Route>
      <Route path="/superadmin/subscriptions/:subscriptionId/edit" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<SubscriptionForm />} />
        </Route>
      </Route>
      <Route path="/superadmin/audit-trail" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<AuditTrail />} />
        </Route>
      </Route>
      <Route path="/superadmin/analytics" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<GrowthAnalytics />} />
        </Route>
      </Route>

      {/* Payroll Routes */}
      <Route path="/payroll/management" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="payroll" />}>
          <Route index element={<PayrollManagement />} />
        </Route>
      </Route>
      <Route path="/payroll/periods" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="payroll" />}>
          <Route index element={<PayrollPeriods />} />
        </Route>
      </Route>
      <Route path="/payroll/components" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="payroll" />}>
          <Route index element={<PayrollComponents />} />
        </Route>
      </Route>
      <Route path="/payroll-management" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="payroll" />}>
          <Route index element={<PayrollManagement />} />
        </Route>
      </Route>
      <Route path="/my-payroll" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="payroll" />}>
          <Route index element={<MyPayroll />} />
        </Route>
      </Route>
      <Route path="/my-payslip/:id" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="payroll" />}>
          <Route index element={<MyPayslipDetail />} />
        </Route>
      </Route>
      <Route path="/admin/payslip/:id" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin']} requiredModule="payroll" />}>
          <Route index element={<MyPayslipDetail />} />
        </Route>
      </Route>

      {/* Headteacher Routes */}
      <Route path="/headteacher" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['headteacher']} requiredModule="dashboard" />}>
          <Route index element={<HeadteacherDashboard />} />
        </Route>
      </Route>
      <Route path="/headteacher/learners" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['headteacher']} requiredModule="students" />}>
          <Route index element={<HeadteacherLearners />} />
        </Route>
      </Route>
      <Route path="/headteacher/teachers" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['headteacher']} requiredModule="teachers" />}>
          <Route index element={<HeadteacherTeachers />} />
        </Route>
      </Route>
      <Route path="/headteacher/classes" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['headteacher']} requiredModule="classes" />}>
          <Route index element={<AllClasses />} />
        </Route>
      </Route>
      <Route path="/headteacher/subjects" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['headteacher']} requiredModule="classes" />}>
          <Route index element={<Subjects />} />
        </Route>
      </Route>
      <Route path="/headteacher/class-subjects" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['headteacher']} requiredModule="classes" />}>
          <Route index element={<ClassSubjects />} />
        </Route>
      </Route>
      <Route path="/headteacher/class-teachers" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['headteacher']} requiredModule="classes" />}>
          <Route index element={<ClassTeacher />} />
        </Route>
      </Route>
      <Route path="/headteacher/students-in-class" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['headteacher']} requiredModule="classes" />}>
          <Route index element={<StudentsInClass />} />
        </Route>
      </Route>
      <Route path="/headteacher/results" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['headteacher']} requiredModule="results" />}>
          <Route index element={<HeadteacherResults />} />
        </Route>
      </Route>
      <Route path="/headteacher/attendance" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['headteacher']} requiredModule="attendance" />}>
          <Route index element={<HeadteacherAttendance />} />
        </Route>
      </Route>
      <Route path="/headteacher/report-cards" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['headteacher']} requiredModule="report_cards" />}>
          <Route index element={<HeadteacherReportCards />} />
        </Route>
      </Route>
      <Route path="/report-cards/viewer" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin', 'headteacher', 'teacher']} requiredModule="report_cards" />}>
          <Route index element={<ReportCardsViewer />} />
        </Route>
      </Route>
      <Route path="/headteacher/notices" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['headteacher', 'admin']} requiredModule="notices" />}>
          <Route index element={<HeadteacherNotices />} />
        </Route>
      </Route>

      <Route path="/superadmin/subjects" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<GlobalSubjects />} />
        </Route>
      </Route>
      <Route path="/superadmin/classes" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<GlobalClasses />} />
        </Route>
      </Route>
      <Route path="/superadmin/roles-permissions" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<RolesPermissions />} />
        </Route>
      </Route>
      <Route path="/superadmin/financial-overview" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<FinancialOverview />} />
        </Route>
      </Route>
      <Route path="/superadmin/system-settings" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<SystemSettings />} />
        </Route>
      </Route>
      <Route path="/superadmin/support" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<SupportTickets />} />
        </Route>
      </Route>
      <Route path="/support" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['admin', 'headteacher', 'teacher']} />}>
          <Route index element={<SupportDesk />} />
        </Route>
      </Route>
      <Route path="/superadmin/maintenance" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<MaintenanceControls />} />
        </Route>
      </Route>
      <Route path="/superadmin/backups" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<BackupRestore />} />
        </Route>
      </Route>
      <Route path="/superadmin/broadcasts" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<BroadcastNotifications />} />
        </Route>
      </Route>
      <Route path="/superadmin/integrations" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<Integrations />} />
        </Route>
      </Route>
      <Route path="/superadmin/subscription-enforcement" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route index element={<SubscriptionEnforcement />} />
        </Route>
      </Route>

      {/* Messaging Routes */}
      <Route path="/messages" element={<LayoutWrapper />}>
        <Route element={<ProtectedRoute allowedRoles={['teacher', 'headteacher', 'student', 'admin']} requiredModule="messaging" />}>
          <Route element={<MessagesPage />}>
            <Route index element={<MessageHome />} />
            <Route path=":id" element={<MessageThreadPage />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
